import * as React from "react";
const SocialMediumIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 40 40",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 20.335C.01 14.068 5.03 8.985 11.19 9c6.199.015 11.208 5.114 11.2 11.4-.007 6.247-5.04 11.333-11.208 11.326C4.97 31.72-.01 26.647 0 20.336Zm34.786.001c.05 2.806-.417 5.496-1.806 7.966-.518.921-1.167 1.74-2.106 2.27-1.276.72-2.655.595-3.775-.352-1.678-1.42-2.443-3.362-2.933-5.425-.698-2.944-.7-5.91-.001-8.855.49-2.063 1.248-4.009 2.933-5.423 1.292-1.083 2.98-1.091 4.271-.02 1.695 1.405 2.486 3.344 2.938 5.414.316 1.445.444 2.763.477 4.419-.023.003-.011.003.001.003s.024 0 .001.003Zm4.36 7.915c.712-2.57.854-6.842.854-7.869 0-1.027-.13-3.406-.308-5.103-.14-1.333-.325-2.672-.971-3.875-.133-.247-.443-.572-.652-.558-.253.017-.598.308-.703.564-.298.725-.566 1.478-.717 2.245-.6 3.046-.718 6.136-.507 9.222.112 1.643.405 3.278.697 4.903l.048.267c.1.559.395 1.105.697 1.597.265.432.65.424.926-.004.273-.425.501-.903.636-1.389Z",
  clipRule: "evenodd"
}));
export default SocialMediumIcon;